import React from 'react';
import { CprDecisionType } from '../../../utils';

interface CprLocationProps {
  cprDecision: CprDecisionType;
  setCprDecision: React.Dispatch<React.SetStateAction<CprDecisionType>>;
}
const CprLocation: React.FC<CprLocationProps> = ({
  cprDecision,
  setCprDecision,
}) => {
  return (
    <div className="govuk-form-group">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="cpr-location">
          The Location of the Cardio-pulmonary resuscitation (CPR) document
        </label>
      </h1>
      <textarea
        className="govuk-textarea"
        id="cpr-location"
        name="CprLocation"
        rows={5}
        placeholder="The location of the CPR document"
        aria-describedby="cpr-location"
        value={cprDecision.location}
        onChange={e => {
          setCprDecision(prev => ({
            ...prev,
            location: e.target.value,
          }));
        }}
      />
    </div>
  );
};

export default CprLocation;
